<template>
  <div>
    <div
      v-for="(template, templateKey) in templates()"
      :key="templateKey"
      class="card"
    >
      <div class="card-header">
        <h4>{{ template.description }}</h4>
      </div>
      <div class="card-body">
        <span
          v-for="(subject, subjectKey) in template.subjects"
          :key="subjectKey"
          class="el-tag el-tag--primary"
        >
          {{ subject.subject }}
          <i
            @click="remove(subject.id)"
            class="el-tag__close el-icon-close"
          ></i>
        </span>
        <input
          type="text"
          placeholder="Neuer Betreff"
          @keyup.enter="persist($event.target, template.id)"
          size="mini"
          class="form-control input-new-tag"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.$store.dispatch("mailSubject/read");
  },
  methods: {
    remove(subject_id) {
      if (!confirm("Diesen Betreff löschen?")) {
        return;
      }
      this.$store
        .dispatch("mailSubject/delete", {
          url: "/api/v1/mailSubject/" + subject_id
        })
        .then(() => {
          this.$store.commit("mailSubject/delete", subject_id);
          this.$notify({
            title: "Der Betreff wurde gelöscht.",
            type: "success"
          });
        })
        .catch(error => {
          if (error.response && error.response.data) {
            this.$notify({
              title: error.response.data,
              type: "error"
            });
          }
        });
    },
    templates() {
      return this.$store.getters["mailSubject/mailSubjects"];
    },
    persist(target, mail_template_id) {
      let subject = target.value;
      this.$store
        .dispatch("mailSubject/create", {
          url: "/api/v1/mailSubject",
          data: { subject, mail_template_id }
        })
        .then(() => {
          target.value = "";
          this.$notify({
            title: "Der Betreff wurde hinzugefügt.",
            type: "success"
          });
        });
    }
  }
};
</script>
